(ns guidebook.views.investment-proposal
  (:require
   [cljss.core :as cljss]
   [graphs.core :refer [pie-chart chart-legend data->colors]]
   [guidebook.common :refer [title-s]]
   [very.re-frame.core :as rf]
   [css.core :refer-macros [defstyled]]))

(defstyled page-s :div
  {:padding "134px"})

(defstyled comparison-s :div
  {:display "grid"
   :padding "0 50px"
   :grid-template-columns "50% 1px 1fr"})

(defstyled subtitle-s :h2
  {:color "black"
   :font-size "25px"
   :margin "60px 0"
   :font-weight 300
   :text-align "center"})

(defstyled vr-s :hr
  {:border "none"
   :border-left "1px solid grey"
   :width "1px"
   :height "460px"
   :margin "0"
   ::cljss/media {[:print]
                  {:height "820px"}}})

(defstyled data-cell-s :div
  {:display "grid"
   :grid-template-columns (with-meta identity :grid-columns)
   :grid-auto-flow "dense"
   :height "400px"
   :padding "0"
   ::cljss/media {[:print]
                  {:grid-template-columns "auto"
                   :grid-template-rows "1fr 1fr"
                   :place-items "center"}}})

(defstyled chart-container-s :div
  {:display "grid"
   :padding "0"
   :justify-items "center"
   ::cljss/media {[:print]
                  {:grid-row-start "1"}}})

(defstyled legend-container-s :div
  {:display "grid"
   :margin-top "6px"
   ::cljss/media {[:print]
                  {:grid-row-start "2"}}})

(defstyled data-cell-title-s :h3
  {:font-size "20px"
   :color "#525151"
   :font-weight "700"
   :text-align (with-meta #(or % "left") :text-align)
   :text-transform "uppercase"
   ::cljss/media {[:print]
                  {:text-align "center"}}})

(defn data-cell-left [data]
  [data-cell-s {:grid-columns "1fr 500px"}
   [legend-container-s [chart-legend data]]
   [chart-container-s [pie-chart {:data data
                                  :opts {:inner-radius 128
                                         :outer-radius 158
                                         :padding-angle 0}}]]])

(defn data-cell-right [data]
  [data-cell-s {:grid-columns "500px 1fr"}
   [chart-container-s [pie-chart {:data data
                                  :opts {:inner-radius 128
                                         :outer-radius 158
                                         :padding-angle 0}}]]
   [legend-container-s [chart-legend data]]])

(defn main []
  (let [data (rf/subscribe [:guidebook/recommendation])]
    (fn []
      (when @data
        (let [current (:current @data) proposed (:proposed @data)]
          [page-s
           [title-s {:max-width "100%"} "Investment Proposal"]
           [subtitle-s "Allocation"]
           [comparison-s
            [:div
             [data-cell-title-s "Current"]
             [data-cell-left
              [{:id "equities" :percent (:equities current) :name "Equities"}
               {:id "fixed-income" :percent (:fixed-income current) :name "Fixed Income"}
               {:id "alternative" :percent (:alternatives current) :name "Alternative"}
               {:id "cash" :percent (:cash current) :name "Cash"}
               {:id "other" :percent (:other current) :name "Other"}]]]
            [vr-s]
            [:div
             [data-cell-title-s {:text-align "right"} "Proposed"]
             [data-cell-right
              [{:id "equities" :percent (:equities proposed) :name "Equities"}
               {:id "fixed-income" :percent (:fixed-income proposed) :name "Fixed Income"}
               {:id "alternative" :percent (:alternatives proposed) :name "Alternative"}
               {:id "cash" :percent (:cash proposed) :name "Cash"}
               {:id "other" :percent (:other proposed) :name "Other"}]]]]])))))
